export default __webpack_public_path__ + "static/media/aboutus-2.d50c656e.jpg";